<template>
	<ListItem
		is-recipient
		:custom-text="text"
	/>
</template>
<script>
import ListItem from "@/vue/communication/conversation/message/ListItem.vue";
import {mapState} from "vuex";

export default {
	components: {
		ListItem
	},

	computed: {
		...mapState('auth', ['application']),
		text ()
		{
			return '<b>Jetzt musst du dich entscheiden!</b><br/>Klicke auf "Jetzt antworten" um der Firma deine Entscheidung mitzuteilen.';
		}
	}
}
</script>
